import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  dustClasses: "Dust.DustClasses",
  list: "Dust.DustClassList",
};

export { names as dustRouteNames };

const dustRoutes: RouterOptions["routes"] = [
  {
    path: "/dust",
    name: names.dustClasses,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Dust Classes",
          lookupGroups: ["DustClassType"],
        },
        component: () => import("@/views/dustClass/DustClassList.vue"),
      },
    ],
  },
];
export default dustRoutes;
